import type { GoverningPolicy } from '../types';

/**
 * The role gate among a tool's governing policies, if any: tool-access-floor, whose shipped branch holds what
 * admin-role-gate and customerless-ops-role-gate did (ADR-0075). It refuses an admin level without the admin
 * role, so the tool is not granted through its level group. The catalog shows the shipped default.
 */
export function roleGateOf(rows: GoverningPolicy[]): GoverningPolicy | undefined {
  return rows.find((row) => row.effect === 'forbid' && row.id === 'tool-access-floor');
}

/** The one-line reading of a role gate for the Tool Manager. */
export function roleGateSummary(gate: GoverningPolicy): string {
  const roles = gate.conditionHint?.replace(/^role:\s*/, '') ?? '';
  const named = roles ? ` (${roles})` : '';
  return `Needs the admin role${named}: ${gate.id} refuses an admin level without it.`;
}
